// Colours as a dashboard writes them (`ColorSchema`, the legacy `CasaColor`): `#rgb`, `#rrggbb`, or
// `#aarrggbb` with its opacity first. CSS and the canvas read eight digits as `#rrggbbaa`, so a colour
// with opacity is turned into `rgba()` before it is painted.

/** A colour as `rgba()`, its opacity times `opacity`; one that cannot be read, as it is. */
export function withOpacity(color: string, opacity: number) : string {
    const hex = color.replace(/^#/, '');
    const full = hex.length === 3 ? `ff${[...hex].map((digit) => digit + digit).join('')}` : hex.length === 6 ? `ff${hex}` : hex;
    const channel = (at: number) : number => Number.parseInt(full.slice(at, at + 2), 16);
    const [alpha, red, green, blue] = [channel(0), channel(2), channel(4), channel(6)];
    if (full.length !== 8 || [alpha, red, green, blue].some(Number.isNaN)) {
        return color;
    }

    return `rgba(${red}, ${green}, ${blue}, ${Number(((alpha / 255) * opacity).toFixed(3))})`;
}

/** A colour as CSS: `#aarrggbb` as `rgba()`, others as they are. */
export const cssColor = (color: string) : string => (/^#[0-9a-fA-F]{8}$/.test(color) ? withOpacity(color, 1) : color);
